import { render, staticRenderFns } from "./ImageViewModal.vue?vue&type=template&id=05175f72&scoped=true&"
import script from "./ImageViewModal.vue?vue&type=script&lang=js&"
export * from "./ImageViewModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewModal.vue?vue&type=style&index=0&id=05175f72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05175f72",
  null
  
)

export default component.exports